import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationRunPrioritySetArgs, Run } from "types/generated";

type FetchRunSetPriorityData = { runPrioritySet: Pick<Run, "id" | "priorityPreset"> };
export const RUN_SET_PRIORITY: TypedDocumentNode<
  FetchRunSetPriorityData,
  MutationRunPrioritySetArgs
> = gql`
  mutation RunPrioritySet($stack: ID!, $run: ID!, $preset: RunPriorityPreset!) {
    runPrioritySet(stack: $stack, run: $run, preset: $preset) {
      id
      priorityPreset
    }
  }
`;
